import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IotElectricStuatsComponent } from './iot-electricity-status.component';

const routes: Routes = [
  // { path: 'masters', component: IotMastersComponent },
  { path: 'electricstatus', component: IotElectricStuatsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ElectricStatusRoutingModule {}
